import { render, staticRenderFns } from "./EditWaterPanel.vue?vue&type=template&id=37443490&scoped=true"
import script from "./EditWaterPanel.vue?vue&type=script&lang=js"
export * from "./EditWaterPanel.vue?vue&type=script&lang=js"
import style0 from "./EditWaterPanel.vue?vue&type=style&index=0&id=37443490&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37443490",
  null
  
)

export default component.exports